import Http from 'common/services/Http';
import { StoppingAreaItemsSearchCriteria } from './models/StoppingAreaItemsSearchCriteria';
import { StoppingAreaItemsListItemDto } from './models/StoppingAreasListItemDto';
import { Paged } from 'api/common/types/Page';
import { StoppingAreasItemConterDto } from './models/StoppingAreasItemConterDto';


class StoppingAreaItemsService {

    public getList(criteria: StoppingAreaItemsSearchCriteria) {
        return Http.get<Paged<StoppingAreaItemsListItemDto>>('stoppingareaitems', criteria);
    }

    public getCounters(criteria: StoppingAreaItemsSearchCriteria) {
        return Http.get<StoppingAreasItemConterDto>('stoppingareaitems/counters-list', criteria);
    }

    
}

export default new StoppingAreaItemsService();
